export function buildProductImageSource(imageUrl) {
  if (!imageUrl) return null;
  return imageUrl;
}
